export default __webpack_public_path__ + "static/media/bedroom.e249f5ec.svg";